import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseErrorState from '@/components/BaseErrorState';

const PasswordNotSetError = () => {
  const { t } = useTranslation();

  return (
    <BaseErrorState
      title={t('coverage.sleepio.not_found_error_state.title')}
      subtitle={t('coverage.pre_onboarding.sleepio.password_not_set_error.subtitle')}
      supportEmail={t('coverage.pre_onboarding.sleepio.password_not_set_error.support.email')}
      supportText={t('coverage.pre_onboarding.sleepio.password_not_set_error.support.text')}
    />
  );
};

export default PasswordNotSetError;
